import { Button } from "@wordpress/components";
import { withDispatch, withSelect } from "@wordpress/data";
// import { useState } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { compose } from "@wordpress/compose";

import { RichText } from "@wordpress/block-editor";
import Style from "./Style";
import Options from "./Options";

const Design = ({ popup, setPopup, isLoading = false }) => {
  const { heading, description, buttons } = popup;

  return (
    <div className="tab_body d-flex justify-between">
      <Style attributes={popup} setAttributes={setPopup} />
      {!isLoading ? (
        <>
          <div className="visible vstr-exit-intent-popup" id="vstr_visitor_feedback">
            <div className="popup">
              <div className="close">&times;</div>
              <RichText tagName="h3" className="heading" value={heading} onChange={(heading) => setPopup({ heading })} />
              <RichText tagName="p" className="text" value={description} onChange={(description) => setPopup({ description })} />
              <div className="form">
                {buttons.map((text, index) => (
                  <div key={index} className="vstr_button_item">
                    <RichText
                      value={text}
                      className="submit"
                      tagName="p"
                      onChange={(text) => {
                        const newButtons = [...buttons];
                        newButtons[index] = text;
                        setPopup({ buttons: newButtons });
                      }}
                    />
                    <span
                      className="close"
                      onClick={() => {
                        buttons.splice(index, 1);
                        setPopup({ buttons });
                      }}
                    >
                      &times;
                    </span>
                  </div>
                ))}
              </div>
            </div>
            <div className="d-flex justify-center m-4">
              <Button variant="primary" onClick={() => setPopup({ buttons: [...buttons, "New Button"] })}>
                {__("Add New Button", "visitor-feedback")}
              </Button>
            </div>
          </div>
          <Options />
        </>
      ) : (
        <h1>Loading...</h1>
      )}
    </div>
  );
};

export default compose([
  withSelect((select) => {
    const { getPopup } = select("visitor-feedback");
    return {
      popup: getPopup(),
    };
  }),
  withDispatch((dispatch) => {
    const { setPopup } = dispatch("visitor-feedback");
    return {
      setPopup,
    };
  }),
])(Design);
